import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=5154d0fd"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5154d0fd')) {
      api.createRecord('5154d0fd', component.options)
    } else {
      api.reload('5154d0fd', component.options)
    }
    module.hot.accept("./BaseTable.vue?vue&type=template&id=5154d0fd", function () {
      api.rerender('5154d0fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTable.vue"
export default component.exports